export enum ScheduleEventType {
	UNSCHEDULED = 'UNSCHEDULED',
	SCHEDULED = 'SCHEDULED',
}
